import axios from 'axios';

export const getDiscounts = async (program_id, type_id) => {
  try {
    const { data: { res } } = await axios.get(
      `https://kivach.ru/calc-new/api_new.php?method=discounts&program_id=${program_id}&type_id=${type_id}`
    );
    return Array.isArray(res) ? res : [];
  } catch (error) {
    console.error('Error fetching discounts:', error);
    return [];
  }
};

export const getUniqueProgramTypes = (rooms) => {
  const pairs = new Map();

  rooms.forEach((room) => {
    room.people.forEach((person) => {
      const programId = person.program?.id;
      const typeId = person.program_type?.id;

      if (programId && typeId) {
        pairs.set(`${programId}-${typeId}`, { program_id: programId, type_id: typeId });
      }
    });
  });

  return Array.from(pairs.values());
};

export const fetchAllDiscounts = async (rooms) => {
  const pairs = getUniqueProgramTypes(rooms);
  if (!pairs.length) {
    return [];
  }

  const results = await Promise.all(
    pairs.map(({ program_id, type_id }) => getDiscounts(program_id, type_id))
  );

  const seen = new Set();

  return results.flat().filter((item) => {
    const key = `${item.start}|${item.end}|${item.text}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return Boolean(item.text?.trim());
  });
};
